<template>
  <v-card class="intern-expansion-panel py-2 px-2" flat tile>
    <DevAddLineInputs
      v-if="showLineInputs"
      :typeLine="lineInputsEdit"
      :objItem="objItem"
      :editableKey="editableKey"
      :headersType="headersType"
      @actionList="actionList"
      @close="closeLine"
    />

    <div class="d-flex justify-end">
      <v-btn @click="showAddObjDefault()" small color="grey darken-3" class="px-2 white--text">
        Adicionar
        <v-icon class="ml-2" small>add</v-icon>
      </v-btn>
    </div>

    <v-expansion-panels class="mt-2" v-for="(item, index) in attrListArrayObj" :key="index" hover multiple focusable tile>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="text-subtitle-2 font-weight-medium grey--text text--darken-3">{{ Object.keys(item)[0] }}</span>
        </v-expansion-panel-header>

        <v-expansion-panel-content class="pt-1">
          <v-expansion-panels class="mt-1" hover multiple focusable tile>
            <div class="mt-1 py-0 d-flex justify-center col-12">
              <v-btn @click="deleteObject(item, index)" small dark color="red" class="px-2">
                <v-icon class="mr-2" small>far fa-trash-alt</v-icon>Deletar
              </v-btn>
            </div>

            <div class="px-3 pt-4 pb-3">
              <v-switch v-model="item[Object.keys(item)[0]].actionsToolbar" label="ActionsToolbar" dense hide-details class="my-2" />
            </div>

            <v-expansion-panel v-for="(itemObject, indexObject) in itemsObject" :key="indexObject" class="v-expansion-panel--expandable-table">
              <v-expansion-panel-header>
                <span class="my-0 pl-2 text-subtitle-2 grey--text text--darken-3">{{ itemObject.text }}</span>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <DevAttrCrudVuetify
                  :value="item[Object.keys(item)[0]][itemObject.value]"
                  :btnAdd="false"
                  :listView="attrListArrayObj"
                  :indexListView="index"
                  :valueDad="value"
                  :nameKey="Object.keys(item)[0]"
                  :btnDelete="false"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    attrListArrayObj: [],
    itemsObject: [
      {
        text: 'Dialog',
        value: 'dialog'
      },
      {
        text: 'Toolbar',
        value: 'toolbar'
      },
      {
        text: 'Card',
        value: 'card'
      }
    ],
    showLineInputs: false,
    lineInputsEdit: false,
    objItem: { key: '', value: '' },
    editableKey: false,
    headersType: false
  }),

  props: {
    value: { type: [Object, Array], default: () => ({} || []) },
    model: { type: Object, default: () => ({}) },
    schema: { type: Object, default: () => ({}) }
  },

  components: {
    DevAddLineInputs: () => import('@/components/dev/dev-add-line-inputs'),
    DevAttrCrudVuetify: () => import('@/components/dev/dev-attr-crud-vuetify')
  },

  mounted() {
    this.getValueList(this.model);
  },

  methods: {
    getValueList(list) {
      this.attrListArrayObj = Object.keys(list).map(i => {
        return { [i]: list[i] };
      });
    },

    showAddObjDefault() {
      this.showLineInputs = true;
    },

    actionList(result) {
      this.addObjDefault(result.key, result.value);
    },

    addObjDefault(key, value) {
      const objectDefault = {
        actionsToolbar: false,
        card: {},
        dialog: {
          persistent: true
        },
        toolbar: {
          fixed: false,
          color: 'indigo',
          class: 'white--text'
        }
      };

      this.attrListArrayObj.push({ [value]: objectDefault });
      this.model[value] = objectDefault;

      this.showLineInputs = false;
    },

    deleteObject(obj, index) {
      this.attrListArrayObj.splice(index, 1);
      delete this.model[Object.keys(obj)[0]];
    },

    closeLine() {
      this.showLineInputs = false;
    }
  }
};
</script>
